import WhatsInBox from '../../images/WhatsInBox.png';

function WhatsInTheBox() {
    return (
        <div style={{ marginLeft: '20px', marginRight: '2.5px', marginTop: '20px' }}>
            <img src={WhatsInBox} style={{ width: '100%', height: '' }} alt="" />
        </div>

    );
}

export default WhatsInTheBox;

